module.exports = __webpack_public_path__ + "static/consider-the-lobster-d3383f2bc89c5d34da91321381c3b457.jpg";